import { useEffect } from "react";

/**
 * Re-runs the given async loader whenever the tab becomes visible again.
 * Combined with polling, ensures public pages always show the latest
 * admin edits without a manual refresh.
 */
export function useLiveRefetch(load, intervalMs = 30000) {
  useEffect(() => {
    if (typeof load !== "function") return;
    let cancelled = false;
    const run = () => {
      if (!cancelled && document.visibilityState === "visible") load();
    };
    const onVis = () => {
      if (document.visibilityState === "visible") load();
    };
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("focus", run);
    const timer = setInterval(run, intervalMs);
    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("focus", run);
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
